<p-dialog [header]="modalTitle" [(visible)]="displayDialog" showeffect="fade" [modal]="true" [styleClass]="'add-dialog'"
  [blockScroll]="true">
  <div class="modal-table-wrapper">
    <div class="modal-loading" *ngIf="isLoading">
      <app-tab-spinner [fixed]="false"></app-tab-spinner>
    </div>
    <div class="modal-content" *ngIf="!isLoading">
      <service-power-table [displayDialog]="displayDialog"></service-power-table>
    </div>
  </div>
  <p-toast> </p-toast>
  <ng-template pTemplate="footer">
    <div class="p-dialog-buttonpane ui-helper-clearfix">
      <button class="crm-button" *ngIf="!isReschedule" type="submit" (click)="onSubmit()" label="Schedule"
        [disabled]="isDisabled || isLoading">
        Schedule Job
      </button>
      <button class="crm-button" *ngIf="isReschedule" type="submit" (click)="onReschedule()" label="Reschedule"
        [disabled]="isDisabled || isLoading">
        Reschedule Job
      </button>
      <button class="crm-button" type="button" (click)="onCancel()" label="Cancel">Cancel</button>
    </div>
  </ng-template>
</p-dialog>